import { createFeatureSelector } from '@ngrx/store';

import { State as cashingState } from './cashing';

/**
 * export cashing selector
 */
export const selectFeatureCashingState = createFeatureSelector<cashingState>('cashing');
